export default __webpack_public_path__ + "static/media/Нэгдсэн уулзалт БЕГ-танилцуулга.0a7b8146.pdf";